/**
 * F-finance-viewer-access — contexto de permissão de EDIÇÃO dentro da Tesouraria.
 *
 * O módulo é acessível a super admin (edita) e ao papel `viewer`/sócio (somente
 * leitura). `canEdit` = super admin. Componentes de escrita (botões, dropdowns
 * inline, ações de linha) consomem `useFinanceCanEdit()` para se esconder/virar
 * read-only quando o usuário é viewer. A segurança real está no backend
 * (mutations em superAdminProcedure); isto é só a camada de UX.
 */
import { createContext, useContext, type ReactNode } from "react";

const FinanceCanEditContext = createContext(false);

export function FinanceAccessProvider({
  canEdit,
  children,
}: {
  canEdit: boolean;
  children: ReactNode;
}) {
  return (
    <FinanceCanEditContext.Provider value={canEdit}>{children}</FinanceCanEditContext.Provider>
  );
}

export function useFinanceCanEdit(): boolean {
  return useContext(FinanceCanEditContext);
}
